import { isMobile } from '../mobile';

const PRINT_ID = 'print-direct';
function printFile(
  url: string,
  afterPrint?: () => void,
  onLoaded?: () => void
) {
  if (!url) return;

  if (isMobile()) return printMobile(url, afterPrint, onLoaded);

  const printSelector: HTMLIFrameElement = document.querySelector(
    `#${PRINT_ID}`
  );
  if (printSelector) printSelector?.remove?.();

  const iframe = document.createElement('iframe');
  iframe.id = PRINT_ID;
  iframe.src = url;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  //? Use onload to make pdf preview work on firefox
  const contentWindow = iframe.contentWindow;
  contentWindow.addEventListener('DOMContentLoaded', () => {
    if (typeof onLoaded === 'function') onLoaded?.();
    contentWindow.focus();
    contentWindow.print();
  });

  window.addEventListener('afterprint', afterPrintFunction);

  function afterPrintFunction() {
    document.querySelector(`#${PRINT_ID}`).remove();
    if (typeof afterPrint === 'function') afterPrint();
  }
}

function printMobile(
  url: string,
  afterPrint?: () => void,
  onLoaded?: () => void
) {
  if (!url) return;
  if (typeof window?.WebViewer !== 'function') return;

  function afterPrintFunction() {
    document.querySelector(`#${PRINT_ID}`).remove();
    if (typeof afterPrint === 'function') afterPrint();
  }

  const printSelector: HTMLIFrameElement = document.querySelector(
    `#${PRINT_ID}`
  );
  if (printSelector) printSelector?.remove?.();

  const iframe = document.createElement('div');
  iframe.id = PRINT_ID;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  return window
    .WebViewer(
      {
        path: (window.PUBLIC_URL || '/') + 'webviewer/lib',
        licenseKey: window?.config?.pdfConfig || 'oNtWh5VY9xigblpArWyL',
        css: (window.PUBLIC_URL || '/') + 'assets/pdf-viewer-dark.css',
        initialDoc: url,
        enableAnnotations: false,
        disabledElements: [
          'ribbons',
          'toggleNotesButton',
          'searchButton',
          'menuButton',
          'rubberStampToolGroupButton',
          'stampToolGroupButton',
          'fileAttachmentToolGroupButton',
          'calloutToolGroupButton',
          'undo',
          'redo',
          'eraserToolButton',
        ],
      },
      iframe
    )
    .then((instance) => {
      instance.Core.documentViewer.addEventListener('documentLoaded', () => {
        instance.UI.useEmbeddedPrint(true);
        instance.UI.setPrintQuality(2);
        instance.UI.printInBackground({
          includeAnnotations: false,
          includeComments: false,
        });
      });

      instance.Core.documentViewer.addEventListener('finishedRendering', () => {
        if (typeof onLoaded === 'function') onLoaded?.();
      });

      instance.Core.documentViewer.addEventListener(
        'afterprint',
        afterPrintFunction
      );
    });
}

export default printFile;
